import { ActionIcon, Box, Group, Popover, Stack, Text } from '@mantine/core';
import { IconCopy } from '@tabler/icons-react';

interface InfoPopoverProps {
  items: string[];
}

export const PopoverInfo = ({ items, ...props }: InfoPopoverProps) => {
  if (items.length <= 1) {
    return null;
  }

  return (
    <Popover withArrow arrowSize={8} position="top" radius={8} shadow="sm" {...props}>
      <Popover.Target>
        <Box p={0} style={{ cursor: 'pointer' }}>
          <Text c="purple.4" fw={500}>
            {`(+${items.length - 1})`}
          </Text>
        </Box>
      </Popover.Target>
      <Popover.Dropdown
        styles={{ dropdown: { borderRadius: 8, padding: '4px 8px 4px 8px' } }}
        bg="gray.10"
      >
        <Stack gap={0}>
          {items.map(item => (
            <Group gap={8} key={item}>
              <Text c="gray.0" fw={500}>
                {item}
              </Text>
              <ActionIcon
                variant="transparent"
                color="gray.4"
                onClick={() => navigator.clipboard.writeText(item)}
              >
                <IconCopy size={18} />
              </ActionIcon>
            </Group>
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
